import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'mapbox-search',
  templateUrl: './mapbox-search.component.html'
})
export class MapboxSearchComponent {

  @Input() searchType;
  @Input() searchParams;
  @Input() currentLocation;

  @Output() search = new EventEmitter();

  modelDetail = '';
  searching = false;
  searchFailed = false;
  disableSearch = false;
  locationsTitle: string;
  nearSearchArray = [];

  constructor(
    private searchService: SearchService,
  ) {}

  formatter = (x: { text: string }) => x.text;

  private getDetail(modelDetail) {
    const item = modelDetail.item.magicKey;
    this.locationsTitle = 'Local selecionado';
    this.searchType.fromLocationSearch = true;
    this.nearSearchArray = [modelDetail.item.text.split(',')[0]];
    this.searchService.sendmagicKey(item);
    this.searchService.getDetail().subscribe((data) => {
      this.searchType.nearSearchLabel = data.attributes.StAddr;
      this.searchParams.location = `${data.location.y},${data.location.x}`;
      this.search.emit();
    });
  }

  private removeLocation() {
    this.locationsTitle = 'Seus endereços';
    this.modelDetail = '';
    this.nearSearchArray = [];
    this.searchType.fromLocationSearch = false;
    this.searchType.nearSearchLabel = 'Minha localização';
    this.searchParams.location = this.currentLocation;
    this.search.emit();
  }

  public searchLocation = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do((search) => {
        if (!search.trim() && !this.nearSearchArray.length) {
          this.searchType.fromLocationSearch = false;
          this.searching = false;
        } else {
          this.searching = true;
        }
      })
      .switchMap(msg => this.searchService.sendSearchKey(msg)
        .do((res) => {
          this.searchFailed = res[0].length > 0;
        })
        .catch((err) => {
          this.searchFailed = true;
          this.disableSearch = true;
          return of([]);
        }))
      .do(() => {
        this.searching = false;
        this.locationsTitle = 'Resultados da busca';
      })
}
